import React from 'react';
import { useSelector } from 'react-redux';
import { Header, Image } from 'semantic-ui-react';
import i18next from 'i18next';
import SelectionItem from './SelectionItem';
import { getMenu } from '../../../selectors';

import './SelectionGroup.scss';

const SelectionGroup = ({ categoryId, onSelected, selections, ...props }) => {
    const menu = useSelector(getMenu);
    const category = menu.catalog.categories[categoryId] || {};
    let items = category.items || [];

    let builderType;
    if (category.options.builderType === 'pizza') {
        builderType = 'pizza';

        const selectedParts = selections.map(s => s.id);

        items = Object.values(items.reduce((result, item) => {
            if (!result[item.extra.itemId]) {
                result[item.extra.itemId] = { id: item.extra.itemId, name: item.name, imageUrl: item.imageUrl, parts: Array(3).fill(null) };
            }
            result[item.extra.itemId].parts[item.meta.pizzaCover] = item;
            if (selectedParts.includes(item.id)) {
                result[item.extra.itemId].selectedPart = item.meta.pizzaCover;
            }
            return result;
        }, {})).map(item => ({ ...item, price: `${Math.max(...item.parts.map(i => i.price))}/${Math.min(...item.parts.map(i => i.price))}` }));
    }
    else if (category.options.limitPerItem > 1) {
        builderType = 'multi';
    }

    function getCategoryHint(category) {
        const hintParts = [];

        if (category.options.deal) {
            hintParts.push(i18next.t(`menu.deal.${category.options.deal.dealType}`, { deal: category.options.deal }));
        }
        if (category.type === 'mandatory') {
            hintParts.push(i18next.t('menu.mustChoose', { count: category.limit || 1 }));
        } else if (category.limit) {
            hintParts.push(i18next.t('menu.pickingLimitation', { count: category.limit }));
        }
        if (category.options.builderType === 'pizza') {
            hintParts.push(i18next.t('menu.pizzaHint'));
        }

        if (!hintParts.length) return null;

        return hintParts.join(' - ');
    }

    return (
        <div className="pi-item-selection-group" {...props}>
            <Header as='h2' className="pi-item-selection-group-header">
                {category.imageUrl && <Image src={category.imageUrl} />}
                <Header.Content>
                    {category.name}
                    <Header.Subheader>{category.description}</Header.Subheader>
                    <Header.Subheader>{getCategoryHint(category)}</Header.Subheader>
                </Header.Content>
            </Header>
            <div className="pi-menu-items-list">
                {items.map(item => (
                    <SelectionItem
                        key={item.id}
                        item={item}
                        builderType={builderType}
                        onSelected={onSelected}
                        count={selections.filter(i => i.id === item.id || (item.parts || []).map(p => p.id).includes(i.id)).length}
                    />
                ))}
            </div>
        </div>
    );
};

export default SelectionGroup;
